/**
 * @copyright 2026 @ DigiNet
 * @author ANHTAI
 * @create 2026/08/10 09:15
 * @update 2026/08/10 09:15
 */

import Config from "../../config/index";

export function eventSteams(urlApi, params, cb) {
    let currentJobId = null;
    function buildEventsUrl(urlApi, jobId) {
        const url = `${urlApi}/{jobId}/events`;
        if (url.includes('{jobId}')) return url.replace('{jobId}', encodeURIComponent(jobId));
        return `${url.replace(/\/$/, '')}/${encodeURIComponent(jobId)}/events`;
    }
    function streamJobEvents(urlApi, jobId) {
        return new Promise((resolve, reject) => {
            const url = buildEventsUrl(urlApi, jobId);
            const es = new EventSource(url);
            const handleEvent = (eventName) => (e) => {
                const { Status = 0, Message } = JSON.parse(e?.data) || {};
                if (eventName === 'completed' || Status === 1) {
                    currentJobId = null;
                    cb && cb(null, { Status, Message });
                    es.close();
                    resolve();
                }
            };
            es.addEventListener('started', handleEvent('started'));
            es.addEventListener('progress', handleEvent('progress'));
            es.addEventListener('failed', handleEvent('failed'));
            es.addEventListener('completed', handleEvent('completed'));
        });
    }
    return async () => {
        let controller = new AbortController();
        try {
            const createJobResponse = await fetch(urlApi.trim(), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'token': Config.token.id,
                },
                body: JSON.stringify(params),
                signal: controller.signal,
            });
            if (!createJobResponse.ok) {
                controller = null;
                return;
            }
            const createJobResult = await createJobResponse.json();
            currentJobId = createJobResult && createJobResult.data ? createJobResult.data.jobId : createJobResult.jobId;
            const { Status, Message } = createJobResult?.data || {};
            if (!currentJobId || Status === 1) {
                controller = null;
                cb && cb(null, { Status, Message });
                return;
            }
            await streamJobEvents(urlApi, currentJobId);
        } catch (err) {
            cb && cb(err, null);
            console.log('request payment error', err);
        } finally {
            controller = null;
            currentJobId = null;
        }
    }
}